import { useContext, useEffect, useState } from 'react';
import { MainContainer } from '../../../components/MainContainer';
import { Dialog } from 'primereact/dialog';
import { FormAddSchedule } from './components/FormAddSchedule';
import { TableSchedule } from './components/TableSchedule';
import { ScheduleNames, GeneralNames } from '../../../namesConstants/names';
import { initialStateTable } from '../../Invitations/const';
import useSchedules from '../../../hooks/catalogs/Schedules/useSchedules';
import { StoreContext } from '../../../business/Provider';
import useReload from '../../../hooks/useReload';

import { ToolbarSearch } from './../../../components/ToolbarSearch/index';

import {
	downloadFileBase64,
	getFileNameWithDateTime
} from '../../../utils/utils';
import { LOADING_OFF, LOADING_ON } from '../../../business/constants';
import { convertTo12HourFormat, dataToExcel } from './utils';
import { useFormik } from 'formik';
import ScheduleObject from './../../../Dto/Catalogs/ScheduleObject';
import ScheduleSchema from './../../../Validations/Catalogs/ScheduleSchema';
import { Toast } from '../../../components/toast';
import { FullLoading } from '../../../components/FullLoading';

const DEFAULT_SORT = [{ field: 'name', order: 1 }]
export const Schedules = () => {
	const {
		getScheduleState,
		getScheduleWorkShiftState,
		dispatchLoading,
		companyState,
		loadingState,
	} = useContext(StoreContext);
	const [sort, setSort] = useState(DEFAULT_SORT);
	const [schedules, setSchedules] = useState([]);
	const [selectedSchedule, setSelectedSchedule] = useState(undefined);
	const [isEdit, setIsEdit] = useState(false);
	const [openDialogAdd, setOpenDialogAdd] = useState(false);
	const [filters, setFilters] = useState(initialStateTable);
	const [globalFilterValue, setGlobalFilterValue] = useState('');
	const [workShifts, setWorkShifts] = useState([]);
	const { getSchedules, getWorkShift, postSchedules, putSchedules } =
		useSchedules();

	const enumDays = {
		2: 'Lun',
		3: 'Mar',
		4: 'Mié',
		5: 'jue',
		6: 'Vie',
		7: 'Sáb',
		1: 'Dom', //
	};

	useEffect(() => {
		clearTextLabel();
	}, []);

	useEffect(() => {
		if (
			getScheduleState.loading === false &&
			getScheduleState.schedules !== undefined &&
			getScheduleState.schedules !== null
		) {
			const _result = getScheduleState.schedules?.results;

			const _resultAddSchedule = _result.map((provider) => {
				let scheduleFormatted =
					provider.starts !== undefined &&
						provider.starts !== null &&
						provider.ends !== undefined &&
						provider.ends !== null
						? `${provider.starts.substring(0, 5)} - ${provider.ends.substring(
							0,
							5
						)}`
						: '';

			const parserRestDays = provider.restDays
				? provider.restDays
					.split(',')
					.map((x) => x.trim())
					.filter((x) => x !== '')
					.sort((a, b) => Number(a) - Number(b))
					.map((num) => enumDays[Number(num)] ?? '')
					.filter((name) => name !== '')
				: [];


				const _provider = { ...provider, schedule: scheduleFormatted, parserRestDays: parserRestDays.join(', ') };
				return _provider;
			});
			setSchedules(_resultAddSchedule);
		}
	}, [getScheduleState]);

	useEffect(() => {
		if (
			getScheduleWorkShiftState.loading === false &&
			getScheduleWorkShiftState.workShifts !== undefined &&
			getScheduleWorkShiftState.workShifts !== null
		) {
			const _result = getScheduleWorkShiftState.workShifts?.results;
			setWorkShifts(_result);
		}
	}, [getScheduleWorkShiftState]);

	useReload([getWorkShift, getSchedules]);

	function onGlobalFilterChange(e) {
		const { value } = e.target;
		const newValue = value.replace(
			'^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$',
			' '
		);
		const _filters = { ...filters };
		_filters.global.value = newValue;
		setFilters(_filters);
		setGlobalFilterValue(newValue);
	}

	function clearTextLabel() {
		const newValue = ''.replace(
			'^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$',
			' '
		);
		const _filters = { ...filters };
		_filters.global.value = newValue;
		setGlobalFilterValue(newValue);
		setFilters(_filters);
	}

	function closeDialog() {
		setOpenDialogAdd(false);
		setIsEdit(false);
		setSelectedSchedule(undefined);
	}

	function getSchedulesByPaginator(page, pageSize) {
		return getWorkShift(page, pageSize);
	}

	async function onSubmitForm() {
		try {
			const {
				code,
				description,
				workShiftDetailId,
				starts,
				ends,
				restDays,
				workShiftId,
			} = formikDataObject.values;

			const payload = {
				workShiftId,
				starts: `${starts}:00`,
				ends: `${ends}:00`,
				code,
				description,
				restDays,
			};

			const result = isEdit
				? await putSchedules(payload, workShiftDetailId)
				: await postSchedules(payload);

			if (result?.status === 200) resetForm();
		} catch (error) {
			console.error('Error submitting form:', error);
		}
	}

	const formikSchedulesConfig = {
		initialValues: { ...ScheduleObject },
		validationSchema: ScheduleSchema,
		onSubmit: onSubmitForm,
	};

	const formikDataObject = useFormik(formikSchedulesConfig);

	function resetForm() {
		closeDialog();
		formikDataObject.resetForm();
	}

	const dialogAddSchedules = () => {
		return (
			<Dialog
				header={
					<p className='text-font-size-base text-[#5e5e5e] font-font-family-base font-bold '>
						{`${isEdit ? 'Editar Turno' : 'Añadir Turno'}`}
					</p>
				}
				className='sm:w-[95vw] md:w-[95vw] lg:w-[95vw] xl:w-[75vw] 2xl:w-[50vw]'
				visible={openDialogAdd}
				modal
				style={{ height: '65vh', position: 'relative' }}
				onHide={() => {
					resetForm();
				}}>
				{
					<div className='flex w-full h-full flex-col relative'>
						<FullLoading loadingState={loadingState} />
						<FormAddSchedule
							onClose={resetForm}
							workShifts={workShifts}
							isEdit={isEdit}
							selectedSchedule={selectedSchedule}
							formikDataObject={formikDataObject}
						/>
					</div>
				}
			</Dialog>
		);
	};
	function addIconFunction() {
		setOpenDialogAdd(true);
	}

	const exportExcel = async () => {
		//TODO: Move all this functions to one util because same logic
		if (schedules.length > 0) {

			dispatchLoading({ type: LOADING_ON });

			const toExcel = dataToExcel(schedules, companyState, sort.length > 0 ? sort : DEFAULT_SORT);
			const fillName = getFileNameWithDateTime('Horarios');
			try {
				 await downloadFileBase64(toExcel, 'xlsx', fillName);
				dispatchLoading({ type: LOADING_OFF });
			} catch (error) {
				dispatchLoading({ type: LOADING_OFF });
			}
		} else {
			Toast('warning', 'No existen registros por exportar');
		}
	};

	const iconsData = [
		{ icon: 'add', title: GeneralNames.GeneralAdd, onClick: addIconFunction },
		{
			icon: 'excel',
			title: GeneralNames.GeneralExportToExcel,
			onClick: exportExcel,
		},
	];

	function handleOnEditSchedule(row) {
		setIsEdit(true);
		setOpenDialogAdd(true);
		const workShiftSelected = workShifts.filter(
			(workShift) => workShift.workShiftId === row.workShiftId
		)[0];

		const formatToHHMM = (value) => {
		if (!value) return '';
		const parts = value.split(':');
		if (parts.length >= 2) {
			return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}`;
		}
		return value;
	};

		formikDataObject.setValues({
			...row,
			workShiftType: workShiftSelected?.shiftWorkingDayType,
			hours: workShiftSelected?.hours,
			workShiftName: workShiftSelected?.name,
			starts: formatToHHMM(row.starts),
			ends: formatToHHMM(row.ends),
			restDays: row.restDays.split(','),
		});
	}

	const renderHeaderGrid = () => {
		return (
			<div className='w-full flex flex-row !h-[60px]'>
				<ToolbarSearch
					onChange={onGlobalFilterChange}
					placeholder={GeneralNames.GeneralNamesSearchGeneral}
					value={globalFilterValue}
					clearTextLabel={clearTextLabel}
					iconsTable={iconsData}
				/>
			</div>
		);
	};
	const renderBodyMain = () => {
		return (
			<div className='w-full h-full flex flex-col'>
				{renderHeaderGrid()}
				<TableSchedule
					list={schedules}
					filters={filters}
					setOpen={setOpenDialogAdd}
					setEdit={setIsEdit}
					setSelectSchedule={setSelectedSchedule}
					handleOnEditSchedule={handleOnEditSchedule}
					getSchedulesByPaginator={getSchedulesByPaginator}
					sort={sort}
					setSort={setSort}
				/>
			</div>
		);
	};
	return (
		<MainContainer cancelTittle nameScreen={ScheduleNames.ScreenTitle}>
			{dialogAddSchedules()}
			{renderBodyMain()}
		</MainContainer>
	);
};
